module.exports = __webpack_public_path__ + "static/media/Khavar_Mianeh.fdf915f4.svg";